<template>
    <div>
        <data-table
            v-if="tableLoaded"
            :exportable="false" 
            title=""
            :rows="getData.rowData"
            :columns="columnData"
            :perPage="perPage"
            :rowsCount="rowsCount"
            :currentPage="currentPage"
            :pageCount="pageCount"
            @changePage="changePage"
            @searchEvent="searchEvent"
            @orderByEvent="orderByEvent"
            @rowClickDelete="onDeleteRow"
            @rowClickPDF="onPDF"
        >
        </data-table>

        <confirm-dialog ref="pdfModal" :title="$t('modal.general.download_pdf')" @buttonClick="onDownloadPDF">
            <p class="m-0">{{ $t('messages.download_pdf') }}</p>
        </confirm-dialog>

        <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import DataTable from '@/components/global/tables/datatables/DataTable.vue';
import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';
import miniToastr from 'mini-toastr';

export default {
    name: 'painting_pdfs_table',
    components: {
        DataTable,
        ConfirmDialog,
    },
    data() {
        return {
            tableNameTranslated: Vue.i18n.translate('table.painting_pdf'),
            tableName: 'painting_pdf',
            row: null,
            tableLoaded: false,
            perPage: 0,
            rowsCount: 0,
            pageCount: 1,
            currentPage: 1,
            sortType: 'asc',
            sortBy: 'id',
            searchInput: '',
            actionTitle: '',

            getData: {
                rowData: [],
            },
            columnData: [
                {
                    label: Vue.i18n.translate('misc.actions'),
                    width: '90px',
                    field: '',
                    showDeleteButton: true,
                    showPDF: true,
                },
                {
                    label: Vue.i18n.translate('table.pdf_no'),
                    field: 'pdf_no',
                    numeric: false,
                    html: false,
                },
                {
                    label: Vue.i18n.translate('table.date'),
                    field: 'date',
                    numeric: false,
                    html: false,
                },
            ],
        }
    },
    mounted() {
        this.onLoadTable();
    },
    methods: {
        successMsg(msg) {
            miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
        },
        errorMsg(msg) {
            miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
        },
        orderByEvent (column, sort_type) {
            this.sortType = sort_type;
            this.sortBy = column.field;
            this.onLoadTable();
        },
        searchEvent (searchInput) {
            this.searchInput = searchInput;
            this.onLoadTable();
        },
        changePage (page) {
            this.currentPage = page;
            this.onLoadTable();
        },
        onLoadTable () {
            http.route(this.tableName + '?project_id=' + this.$route.params.id + '&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get()
            .then(response => {
                if (!response.isError) {
                    this.perPage     = response.pagination.limit;
                    this.rowsCount   = response.pagination.totalEntries;
                    this.currentPage = response.pagination.currentPage;
                    this.pageCount   = response.pagination.totalPages;

                    this.getData.rowData = response.data;
                    this.tableLoaded = true;
                } else {
                    Object.keys(response.errorMessage).forEach(key => {
                        this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                    });
                }
            });
        },
        onDeleteRow (row, index) {
            this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
            this.row = row;
            this.$refs.deleteModal.show();
        },
        deleteAction (button) {
            if (button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).delete();
                data.then(response => {
                    if (!response.isError) {
                        if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                            this.currentPage = this.currentPage - 1;
                        }

                        this.onLoadTable();
                        this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                    } else {
                        this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                    }
                });
            }
            this.$refs.deleteModal.hide();
        },
        onPDF (row) {
            this.row = row;
            this.$refs.pdfModal.show();
        },
        onDownloadPDF (button) {
            if(button == 1) {
                let data = http.route(this.tableName + '/' + this.row.id).get(
                {
                    export_pdf: 1
                }, true);
                data.then(response => {
                    if (!response.isError) {
                        let data = http.route('get_content/'+response.data.type+'/'+response.data.id+'/'+response.data.name).downloadPdf({}, response.data.name).then(res => {
                            if (typeof res == 'undefined') {
                                miniToastr.success(Vue.i18n.translate('messages.pdf_generated'), Vue.i18n.translate('messages.success'));
                            } else {
                                Object.keys(res.errorMessage).forEach(key => {
                                    this.errorMsg(Vue.i18n.translate(res.errorMessage[key]));
                                });
                            }
                        });
                    } else {
                        miniToastr.error(Vue.i18n.translate('errors.error_generating_pdf'), Vue.i18n.translate('messages.error'));
                    }
                });
            }

            this.$refs.pdfModal.hide();
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/construction/painting/painting_pdfs_table.vue